export const purpurBorderRadiusXs = "2px";
export const purpurBorderRadiusSm = "4px";
export const purpurBorderRadiusMd = "8px";
export const purpurBorderRadiusLg = "16px";
export const purpurBorderRadiusXl = "24px";
export const purpurBorderRadiusFull = "999px";
export const purpurBorderWidthXs = "1px";
export const purpurBorderWidthSm = "2px";
export const purpurBorderWidthMd = "3px";
export const purpurBorderWidthLg = "6px";
